export default function is0800Number(phoneNumber) {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    return cleanedNumber.startsWith('0800');
}